import { render, staticRenderFns } from "./componentDate.vue?vue&type=template&id=530bc27a&scoped=true&"
import script from "./componentDate.vue?vue&type=script&lang=ts&"
export * from "./componentDate.vue?vue&type=script&lang=ts&"
import style0 from "./componentDate.vue?vue&type=style&index=0&id=530bc27a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bc27a",
  null
  
)

export default component.exports